module.exports = __webpack_public_path__ + "img/Dexter Grimsley.2cf7083d.jpg";